module.exports = __webpack_public_path__ + "img/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-2.648992e7.jpg";